import React, { FC } from 'react';

import { AreaModes, AreaTypes, IArea } from '../../../models/types';
import { ReactComponent as InfrastructureSvg } from '../../../assets_/icons/infrastructure.svg';
import { useGeomanControl } from '../../../hooks/useGeomanControl';

interface IProps {
  setAreaCoordinates: (coordinates: number[]) => void;
  setBeaconCoordinates: (coordinates: number[]) => void;
  setOfficeCoordinates: (coordinates: number[]) => void;
  setCameraCoordinates: (coordinates: number[]) => void;
  setMarkerEditMode: (...args: any[]) => void;
  setBoxEditMode: (...args: any[]) => void;
  setCircleEditMode: (...args: any[]) => void;
  setPolygonEditMode: (...args: any[]) => void;
  mode: AreaModes;
  type: AreaTypes;
  areaEdit?: IArea | null;
  coordinates?: number[] | null; // Accepted but unused (kept for parent component compatibility)
}

/**
 * EditControl component for managing map drawing and editing using Leaflet-Geoman
 * Main version - handles creating and editing areas (Rectangle, Circle, Polygon) and markers (office, beacon, camera)
 */
const EditControl: FC<IProps> = ({
  mode,
  type,
  setAreaCoordinates,
  setBeaconCoordinates,
  setOfficeCoordinates,
  setCameraCoordinates,
  setMarkerEditMode,
  setBoxEditMode,
  setCircleEditMode,
  setPolygonEditMode,
  areaEdit,
  coordinates
}) => {
  // Use shared Geoman control hook
  useGeomanControl({
    mode,
    type,
    setAreaCoordinates,
    setBeaconCoordinates,
    setOfficeCoordinates,
    setCameraCoordinates,
    setMarkerEditMode,
    setBoxEditMode,
    setCircleEditMode,
    setPolygonEditMode,
    areaEdit,
    MarkerIcon: InfrastructureSvg
  });

  return null; // Geoman adds controls directly to the map
};

export default EditControl;
